// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const IntegrationGuidePageSelector: MarkdocTagRegistration = {
  tag: 'tax-integration-guide-page-selector',
  component: 'IntegrationGuidePageSelector',
};
